<script setup lang="ts">
import { useHead } from "@unhead/vue"
import { TooltipProvider } from "reka-ui"
import { OfflineBanner } from "@/components"
import { ToastContainer } from "@/components/ui"
import { useTranslation } from "@/composables/useTranslation"
import { languageMetadata } from "@/i18n/constants"

const { locale } = useTranslation()

useHead({
  htmlAttrs: {
    lang: () => locale.value,
    dir: () => (languageMetadata[locale.value]?.rtl ? "rtl" : "ltr"),
  },
})
</script>

<template>
  <OfflineBanner />
  <TooltipProvider>
    <RouterView />
  </TooltipProvider>
  <ToastContainer />
</template>
